var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-info"},[_c('div',{staticClass:"info-title"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.$slots.desc)?_c('span',{staticClass:"desc"},[_vm._t("desc")],2):_vm._e()]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }